export const version = '0.386.3'
export const chameleonWebVersion = '0.0.0-snapshot-20230412094309'
